import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var LockIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 3.34315 7.34315 2 9 2C10.6569 2 12 3.34315 12 5V7H13C13.5523 7 14 7.44772 14 8V14.382C14 14.7607 13.7853 15.1055 13.4302 15.2373C12.6332 15.533 11.0501 16 9 16C6.94992 16 5.36682 15.533 4.56982 15.2373C4.21471 15.1055 4 14.7607 4 14.382V8C4 7.44772 4.44772 7 5 7H6V5ZM7.5 7H10.5V5C10.5 4.17157 9.82843 3.5 9 3.5C8.17157 3.5 7.5 4.17157 7.5 5V7ZM8 10C8 9.44772 8.44772 9 9 9C9.55228 9 10 9.44772 10 10V12C10 12.5523 9.55228 13 9 13C8.44772 13 8 12.5523 8 12V10Z"
  }));
});
LockIcon.displayName = 'LockIcon';
export default LockIcon;